/**
 * Per-platform card theming, shared by the dashboard Connected Accounts cards
 * and the Settings integration cards.
 *
 * `bar`   — top accent stripe (gradients for the multi-hue brands).
 * `tint`  — a single solid hex for borders, header washes, and rings; chosen to
 *           read on BOTH light and dark grounds.
 * `badge` — icon-tile fill (gradient for Instagram/TikTok, solid otherwise).
 *
 * The pure-black brands (TikTok, X) deliberately use visible accent colours
 * instead of #000000, which would vanish in dark mode.
 */
export const BRAND_THEME = {
  YOUTUBE:   { bar: '#FF0000',                                                        tint: '#FF0000', badge: '#FF0000' },
  INSTAGRAM: { bar: 'linear-gradient(90deg,#feda75,#fa7e1e,#d62976,#962fbf,#4f5bd5)', tint: '#d62976', badge: 'linear-gradient(135deg,#feda75,#d62976,#4f5bd5)' },
  FACEBOOK:  { bar: '#1877F2',                                                        tint: '#1877F2', badge: '#1877F2' },
  TWITCH:    { bar: '#9146FF',                                                        tint: '#9146FF', badge: '#9146FF' },
  TIKTOK:    { bar: 'linear-gradient(90deg,#25F4EE,#FE2C55)',                         tint: '#FE2C55', badge: 'linear-gradient(135deg,#25F4EE,#FE2C55)' },
  TWITTER:   { bar: '#1d9bf0',                                                        tint: '#1d9bf0', badge: '#1d9bf0' },
};

/** Returns the theme for a platform value, falling back to a neutral tint. */
export const getPlatformTheme = (platformValue, fallbackColor = '#6b7280') =>
  BRAND_THEME[platformValue] || { bar: fallbackColor, tint: fallbackColor, badge: fallbackColor };
